




















import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: 'BillLadingSuggestConfirmToTable',
    components: {TooltipLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() dataSource!: any;
    @PropSync('form') formSync!: any;

    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50
        },
        {
            title: "Mã vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "Tỉnh đến",
            dataIndex: "locationTo.province.name",
            key: "locationToProvince",
            width: 120,
            ellipsis: true
        },
        {
            title: "TL(g)",
            dataIndex: "weightTemp",
            key: "weightTemp",
            width: 100,
            scopedSlots: { customRender: 'weightTemp' }
        },
        {
            title: "SK",
            dataIndex: "boxQuantity",
            key: "boxQuantity",
            width: 80,
            ellipsis: true
        },
        {
            title: "Dịch vụ",
            dataIndex: "freightService.serviceCode",
            key: "ladingFreightService",
            width: 120,
            ellipsis: true
        },
        // {
        //     title: "DV_GTGT",
        //     dataIndex: "freightService.serviceCode",
        //     key: "ladingFreightServiceAdd",
        //     width: 100
        // },
        {
            title: "Thu tiền NN",
            dataIndex: "receiverCollect",
            key: "receiverCollect",
            width: 150,
            ellipsis: true,
            scopedSlots: { customRender: 'receiverCollect' }
        }
    ];

    onSelectChange(selectedRowKeys: string[]) {
        this.formSync.ladingRowGuids = selectedRowKeys as any;
    }
}
